import { render, staticRenderFns } from "./EmailQueueStats.vue?vue&type=template&id=42e13564"
import script from "./EmailQueueStats.vue?vue&type=script&lang=js"
export * from "./EmailQueueStats.vue?vue&type=script&lang=js"
import style0 from "./EmailQueueStats.vue?vue&type=style&index=0&id=42e13564&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports